<template lang="">
    <section class="px-5 lg:px-28 clear-both">
        <div class="flex justify-center text-center w-full mx-auto" v-if="showHeader"
        :class="{
            '!justify-start': headerPosition=='left',
            '!justify-end': headerPosition=='right'}">
            <div class="h-full flex flex-col" >
                <p class="text-[#616161] skeleton-box w-[150px] h-[15px] mb-2"></p>
                <h6 class="text-secondary text-[1.625rem] mb-2 font-medium  skeleton-box w-[200px] h-[15px]"></h6>
            </div>
        </div>
      <!-- <products-slider :content="featuredProductsSection.data" class="mt-20" /> -->
        <div  class="grid lg:grid-cols-4 2xl:grid-cols-5  md:grid-cols-3 grid-cols-2 gap-4 mt-20" :class="{'lg:!grid-cols-3': isHasSide}" >
            <div v-for="(product, index) in productsList" :key="index" class=" product-card-vertical w-full h-full flex flex-col max-w-sm mx-auto lg:mx-0 md:mx-0 bg-white rounded-lg border border-gray-200 md:h-[400px]">
                <!-- product image -->
                <div  class="product-card-vertical_img relative min-h-[190px] ">
                    <div class="skeleton-box rounded-t-lg w-full h-[190px] max-h-[190px]"></div>
                </div>
                <div class="product-card-vertical_info p-4 relative h-full flex flex-col min-h-[184px] w-full ">
                    <p class="product-card-vertical_price text-sm text-dark-gray-9 mb-4 skeleton-box w-[80px] h-[15px]"></p>
                    <p class="product-card-vertical_title text-dark-gray-3 mb-2 truncate leading-[16px] skeleton-box w-[50px] h-[15px]"></p>
                    <p  class="text-dark-gray-3 font-medium mb-4 skeleton-box w-[35px] h-[15px]"></p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    props:['showHeader', 'headerPosition', 'isHasSide'],
    data() {
        return {
            productsList:['','','','']
        }
    }
}
</script>
<style lang="">
    
</style>